"use client";

import React, { useLayoutEffect, useRef } from "react";

// Define desired thresholds for snapping width
export const STEPS = [35, 70, 95, 130];

export const SnappedWidth = ({
  children,
  className = "",
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  const ref = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;

    // Reset width to 'auto' to measure natural size
    el.style.width = "auto";
    const naturalWidth = el.scrollWidth;

    const nextStep = STEPS.find((step) => step >= naturalWidth);
    el.style.width = nextStep ? `${nextStep}px` : `${naturalWidth}px`;
  });

  return (
    <div ref={ref} className={`flex-none ${className}`}>
      {children}
    </div>
  );
};

export default SnappedWidth;
